import { gql, useMutation } from '@apollo/client';
import { SIGNATURE_REQUEST_FIELDS } from './useSignatureRequestCreateMutation';

const RESEND_SIGNATURE_REQUEST = gql`
  ${SIGNATURE_REQUEST_FIELDS}
  mutation ResendSignatureRequest($requestId: String!, $signeeId: String!) {
    resendSignatureRequest(requestId: $requestId, signeeId: $signeeId) {
      ...SignatureRequestFields
    }
  }
`;

export interface ResendSignatureRequestInput {
  requestId: string;
  signeeId: string;
}

export interface ResendSignatureRequestResult {
  resendSignatureRequest: {
    id: string;
  };
}

export function useResendSignatureRequestMutation() {
  return useMutation<ResendSignatureRequestResult, ResendSignatureRequestInput>(RESEND_SIGNATURE_REQUEST, {
    refetchQueries: ['GetCompany', 'GetUserValues'],
  });
}
